import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import LoadingSpinner from "../components/common/LoadingSpinner";

/**
 * PublicOnly — inverse of AdminAuth. Wraps routes that should ONLY be seen
 * while logged OUT (the login page). If an authenticated session exists, the
 * user is bounced to /admin with `replace`, so:
 *   - typing "/" in the URL bar redirects to the dashboard, and
 *   - the browser Back button can't land on the login page (the route
 *     re-evaluates auth on every render and the replace keeps it out of history).
 */
export default function PublicOnly({ children }) {
  const { userToken, loading } = useAuth();

  if (loading) return <LoadingSpinner label="Checking session..." />;
  if (userToken) return <Navigate to="/admin" replace />;

  return children;
}
